import { useMemo } from 'react'
import _ from 'lodash'

import { useCurrentUser, useFeatureFlag } from 'hooks'
import {
  MeasurementType,
  TimeUnit,
  UnitConfig,
  UnitSystem,
  UserPreferencesUnitConfig,
} from 'app/MissionControlMethaneSolution/types/common'
import { FEATURES } from 'constants/settings'
import { DEFAULT_METHANE_DENSITY } from 'app/MissionControlMethaneSolution/constants/common'

export const defaultValues: UserPreferencesUnitConfig = {
  measurementType: MeasurementType.MASS,
  unitSystem: UnitSystem.METRIC,
  timeUnit: TimeUnit.HOUR,
  methaneDensity: DEFAULT_METHANE_DENSITY,
}

export const useEmissionUnitsPreference = (): UnitConfig => {
  const { [FEATURES.EMISSION_EVENTS]: emissionEventEnabled } = useFeatureFlag()

  const { currentUser } = useCurrentUser()

  return useMemo(() => {
    const preferences = _.defaults(
      emissionEventEnabled
        ? currentUser?.preferences?.units?.emissionEvents
        : {},
      defaultValues
    )

    return {
      system: preferences.unitSystem,
      type: preferences.measurementType,
      timeUnit: preferences.timeUnit,
      methaneDensity: preferences.methaneDensity,
    }
  }, [currentUser?.preferences?.units?.emissionEvents, emissionEventEnabled])
}
